import { render, staticRenderFns } from "./companyBaseInfo.vue?vue&type=template&id=12a50fcf&scoped=true"
import script from "./companyBaseInfo.vue?vue&type=script&lang=js"
export * from "./companyBaseInfo.vue?vue&type=script&lang=js"
import style0 from "./companyBaseInfo.vue?vue&type=style&index=0&id=12a50fcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a50fcf",
  null
  
)

export default component.exports